import Popover, { PopoverProps } from '.';
import React from 'react';

// This object should contain a mock value for each required prop of this component
export const requiredProps: PopoverProps = {};

// This array should contain an object only for tests you wish to run on all compliance tests
const sharedTests = [
  {
    title: 'render',
    props: {
      ...requiredProps,
    } as PopoverProps,
  },
];

export const testkitTests = [
  {
    title: 'render',
    props: {
      ...requiredProps,
      children: [
        <Popover.Element>
          <div>I am the trigger!</div>
        </Popover.Element>,
        <Popover.Content>
          <div>I am the content!</div>
        </Popover.Content>,
      ],
    } as PopoverProps,
  },
];

export const ssrTests = [...sharedTests];

export const a11yTests = [...sharedTests];
